module.exports = __webpack_public_path__ + "ipetbooking-landing/img/pic03@1.ed4d4408.jpg";